
import { useStore } from "@/store";
import { computed, defineComponent, ref } from "vue";

const store = useStore();
export default defineComponent({
  name: "OnLinePlayers",
  setup() {
    const TradeDialog = ref();
    const playerList = computed(() => {
      return store.state.onlinePlayers;
    });
    const handleGive = (id: number) => {
      TradeDialog.value.open(id);
    };
    const wsId = computed(() => {
      return store.state.wsId;
    });
    return {
      playerList,
      handleGive,
      TradeDialog,
      wsId
    };
  }
});
